<template>
  <div
    v-if="!loading"
    class="min-h-screen bg-off-white pb-12 pt-6"
  >
    <div class="pb-6">
      <img
        v-if="brokerLogo"
        class="mx-auto hidden h-11 w-auto md:block"
        :src="brokerLogo"
        alt="broker logo"
      />
    </div>
    <div class="px-4 sm:px-0">
      <pending-review
        v-if="isDisplayPendingReviewInsteadOfFailedAssessment"
        :company-type="companyType"
        :company-name="brokerName"
      />
      <component
        :is="statusComponents[onboardingPacket.status]"
        v-else-if="
          hasSentEldCertificationInvite ||
          !hasFailedPhysicalLocationActivityVerification ||
          latest_carrier_eld_provider?.has_setup_manual_connection == true ||
          latest_carrier_eld_provider?.has_completed_connect_channel == true ||
          latest_carrier_eld_provider?.document?.filename?.length > 0
        "
        :company-type="companyType"
        :loading="loading"
        :company-name="companyName"
        :support-email="supportEmail"
        :failed-rules="failedRulesByClassification"
        :unique-failed-rules="uniqueFailedRules"
        :incomplete-rules="incompleteRulesByClassification"
        :unique-incomplete-rules="uniqueIncompleteRules"
        :total-rules="totalRules"
        :broker-logo="brokerLogo"
        :rules-syntax="rulesSyntax"
      />
      <failed-physical-location-activity-verification
        v-else
        :company-type="companyType"
        :loading="loading"
        :company-name="companyName"
        :support-email="supportEmail"
        :failed-rules="failedRulesByClassification"
        :unique-failed-rules="uniqueFailedRules"
        :incomplete-rules="incompleteRulesByClassification"
        :unique-incomplete-rules="uniqueIncompleteRules"
        :total-rules="totalRules"
        :broker-logo="brokerLogo"
        :rules-syntax="rulesSyntax"
      />
    </div>
    <!-- <failed-physical-location-activity-verification
      :companyType="companyType"
      :loading="loading"
      :companyName="companyName"
      :supportEmail="supportEmail"
      :failedRules="failedRulesByClassification"
      :uniqueFailedRules="uniqueFailedRules"
      :incompleteRules="incompleteRulesByClassification"
      :uniqueIncompleteRules="uniqueIncompleteRules"
      :totalRules="totalRules"
      :brokerLogo="brokerLogo"
      :rulesSyntax="this.rulesSyntax"
    >
    </failed-physical-location-activity-verification> -->
  </div>
  <div
    v-else
    class="tablet-desktop-container mx-auto flex h-80 max-w-2xl items-center justify-center overflow-scroll pt-12 md:overflow-hidden"
  >
    <img
      class="-top-2px loading relative h-12 w-full"
      src="@/assets/loading-v2-yellow.svg"
      alt=""
    />
  </div>
</template>
<script>
import { shallowRef } from 'vue';
import AwaitingApproval from '@/components/holding-tanks/AwaitingApproval.vue';
import OnboardingComplete from '@/components/holding-tanks/OnboardingComplete.vue';
import IncompleteAssessment from '@/components/holding-tanks/IncompleteAssessment.vue';
import FailedAssessment from '@/components/holding-tanks/FailedAssessment.vue';
import PendingReview from '@/components/holding-tanks/PendingReview.vue';
import FailedPhysicalLocationActivityVerification from '@/components/holding-tanks/FailedPhysicalLocationActivityVerification.vue';

const incompleteAssessment = shallowRef(IncompleteAssessment);
const awaitingApproval = shallowRef(AwaitingApproval);
const failedAssessment = shallowRef(FailedAssessment);
const onboardingComplete = shallowRef(OnboardingComplete);

export default {
  name: 'Onboarding Packet Status',
  components: {
    FailedPhysicalLocationActivityVerification,
    PendingReview,
  },
  data() {
    return {
      statusComponents: {
        held_for_incomplete_rules_assessment: incompleteAssessment,
        held_for_carrier_approval: awaitingApproval,
        held_for_failed_rules_assessment: failedAssessment,
        complete: onboardingComplete,
      },
      isLoading: true,
      uniqueFailedRules: [],
      uniqueIncompleteRules: [],
    };
  },
  computed: {
    isDisplayPendingReviewInsteadOfFailedAssessment() {
      return (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.is_display_pending_review_instead_of_failed_assessment || false
      );
    },
    brokerName() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer
        ?.legal_name;
    },
    classifications() {
      return [
        ...new Set(
          this.$store.state.carriers.carrierData?.rules_assessment
            ?.classifications ?? []
        ),
      ];
    },
    companyType() {
      return this.$store.state.users.currentUser.company.company_type;
    },
    companyName() {
      return this.$store.state.users.currentUser.company.legal_name;
    },
    brokerLogo() {
      return this.$store.state.company?.company?.logo?.url || null;
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    companyId() {
      return this.$store.state.users.currentUser.company.carrier_id;
    },
    supportEmail() {
      return this.$store.state.company.company?.support_email;
    },
    onboardingPacket() {
      return this.$store.state.onboardingPacket;
    },
    onboardingPacketStatus() {
      return this.$store.state.onboardingPacket?.status;
    },
    hasAttemptedCompletedRedirect() {
      return this.$store.state.onboardingPacket
        ?.has_attempted_completed_redirect;
    },
    testrules() {
      return (
        this.$store.state.carriers.carrierData.rules_assessment.summary || {}
      );
    },
    hasFailedPhysicalLocationActivityVerification() {
      const eldSensitiveRuleSets =
        this.$store.state.onboardingPacket.eld_sensitive_rule_sets;
      let returnVal = false;
      let self = this;
      eldSensitiveRuleSets.forEach((rule_set) => {
        if (self.uniqueFailedRules?.includes(rule_set)) {
          returnVal = true;
        }
      });

      return returnVal;
    },
    hasSentEldCertificationInvite() {
      return this.latest_carrier_eld_provider?.has_sent_certification_invite;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    failedRulesByClassification() {
      let arr = [];
      this.classifications.forEach(function (el) {
        let result = Object.keys(el.rules).map(function (key) {
          if (el.rules?.[key]?.result == 'fail' && key !== 'result') {
            return { rule: key, value: el.rules?.[key]?.result };
          }
        });
        let filteredResult = result.filter((x) => x !== undefined);
        if (filteredResult?.length > 0) {
          let returnVal = {
            name: el.name,
            id: el.id,
            rules: filteredResult,
          };
          arr.push(returnVal);
        }
      });
      return arr;
    },
    incompleteRulesByClassification() {
      let arr = [];
      this.classifications.forEach(function (el) {
        let result = Object.keys(el.rules).map(function (key) {
          if (el.rules?.[key]?.result == 'incomplete' && key !== 'result') {
            return { rule: key, value: el.rules?.[key]?.result };
          }
        });
        let filteredResult = result.filter((x) => x !== undefined);
        if (filteredResult?.length > 0) {
          let returnVal = {
            name: el.name,
            id: el.id,
            rules: filteredResult,
          };
          arr.push(returnVal);
        }
      });
      return arr;
    },
    rulesAssessment() {
      let arr = [];
      this.classifications.forEach(function (el) {
        for (const key in el.rules) {
          if (key !== 'result') {
            arr.push({
              rule: key,
              value: el.rules?.[key]?.result,
            });
          }
        }
      });
      console.log('rulesA');
      console.log(arr);
      // const unqiueRules = arr.reduce((accum, obj) => {
      //   for (const key in obj) {
      //     if (key !== 'result') {
      //       accum[key] = accum[key] ? [...accum[key], obj[key]] : obj[key];
      //     }
      //   }
      //   return accum;
      // }, { });
      let seen = [];
      const uniqueRules = arr.filter(function (el) {
        if (!seen.includes(el.rule)) {
          seen.push(el.rule);
          return el;
        }
      });
      return uniqueRules;
    },
    rulesSyntax() {
      return this.$store.state.carriers?.rulesSyntax;
    },
    totalRules() {
      return this.rulesAssessment?.length;
    },
    broker_sign_in_with_highway_link() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer
        ?.sign_in_with_highway_link;
    },
  },
  watch: {
    '$store.state.carriers.carrierData.rules_assessment.summary': function (
      val
    ) {
      if (Object.keys(val).length > 0) {
        this.$store.commit('loading/loadingToggleOff', null, {
          root: true,
        });
      }
    },
    rulesAssessment: function (val) {
      if (val?.length > 0) {
        this.uniqueFailedRules = this.calculateRules('fail');
        this.uniqueIncompleteRules = this.calculateRules('incomplete');
      }
    },
    // onboardingPacketStatus: function(val) {
    //   if (val == 'held_for_failed_rules_assessment') {
    //     this.attemptCompletedRedirect();
    //   }
    // },
    broker_sign_in_with_highway_link: function (val) {
      console.log(val);
      if (
        val?.length > 0 &&
        this.onboardingPacketStatus == 'complete' &&
        !this.hasAttemptedCompletedRedirect
      )
        this.attemptCompletedRedirect();
    },
  },
  async created() {
    // if you landed here, we don't want to keep banging you back
    // to the OAuth screen
    // localStorage.removeItem('redirect_url_after_sigin');
    if (this.$store.state.onboardingPacket?.has_attempted_completed_redirect) {
      localStorage.removeItem('redirect_url_after_sigin');
    }
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    await this.$store.dispatch('onboardingPacket/getOnboardingPacketById', {
      id: this.$route.params.id,
    });
    await this.updateLatestEldProviderAndIntegration();
    await this.$store.dispatch('carriers/getRulesSyntax');
    await this.$store.dispatch(
      'company/getCompanyByClientId',
      localStorage.getItem('client_id')
    );
  },
  methods: {
    calculateRules(result) {
      // let arr = [];
      // for (const [key, value] of Object.entries(this.rulesAssessment)) {
      //   if (value == result) {
      //     arr.push(key);
      //   }
      // }
      let arr2 = this.rulesAssessment.filter(function (el) {
        return el.value == result;
      });
      console.log('arr2 - ' + result);
      console.dir(arr2);
      let arr3 = [];
      if (arr2 && arr2?.length > 0) {
        arr2.forEach(function (el) {
          arr3.push(el.rule);
        });
      }
      return arr3;
    },
    getRedirectUrlAfterSignIn: async function () {
      let redirectAfterSignIn;
      let inLocalStorage = false;
      try {
        redirectAfterSignIn = JSON.parse(
          localStorage.getItem('redirect_url_after_sigin')
        );
        inLocalStorage = true;
      } catch {
        redirectAfterSignIn =
          this.$store.state.brokers?.localStorage?.redirect_url_after_sigin ||
          this.broker_sign_in_with_highway_link;
      }

      console.log('redirectAfterSignIn', redirectAfterSignIn);

      if (redirectAfterSignIn) {
        if (inLocalStorage) {
          localStorage.removeItem('redirect_url_after_sigin');
        }
        this.$store.commit(
          'addFormDebugMessage',
          `REDIRECT | Onboarding Packet Status: Redirecting to redirect_url_after_sigin`
        );
        return redirectAfterSignIn;
      } else {
        this.$store.commit(
          'addFormDebugMessage',
          `REDIRECT | Onboarding Packet Status: redirect_url_after_sigin is not present in localStorage or store, no redirect will occur`
        );
        return false;
      }
    },
    attemptCompletedRedirect: async function () {
      if (this.hasAttemptedCompletedRedirect) {
        return;
      }
      this.$store.commit(
        'onboardingPacket/setHasAttemptedCompletedRedirect',
        true
      );
      let redirectUrl = await this.getRedirectUrlAfterSignIn();
      console.log('attemptCompletedRedirect - attempting now');
      console.dir(redirectUrl);
      if (redirectUrl) {
        if (typeof redirectUrl === 'object') {
          return this.$router.push(redirectUrl);
        } else {
          window.location.href = redirectUrl;
        }
      }
    },
    async updateLatestEldProviderAndIntegration() {
      let res = await this.$store.dispatch(
        'onboardingPacket/getLatestEldProvider',
        this.$store.state.users?.currentUser?.company?.carrier_id
      );
      if (res?.data?.[0]?.integration?.id > 0) {
        await this.$store.dispatch(
          'onboardingPacket/getEldIntegrationById',
          res?.data?.[0]?.integration?.id
        );
      }
    },
  },
};
</script>
